import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { formatAmount } from "../../../utils/hooks/dataHandler";

const ShareOfExpenses = ({ companyType, shareOfExpenses }) => {
  const isInvestmentCompany = companyType === "investment";

  if (!isInvestmentCompany) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 2,
          flexWrap: "wrap",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Typography
            variant='caption'
            sx={{
              textTransform: "uppercase",
              letterSpacing: 0.5,
              fontSize: "0.75rem",
              fontWeight: 600,
            }}
          >
            Share of Expenses
          </Typography>
          <Typography
            variant='body2'
            color='text.secondary'
            sx={{ fontSize: "0.875rem", fontWeight: 600 }}
          >
            {shareOfExpenses.source && `Source: ${shareOfExpenses.source}`}
          </Typography>
        </Box>
        {/* Right: Amount */}
        <Box sx={{ textAlign: "right" }}>
          <Typography
            variant='body2'
            sx={{
              fontWeight: 600,
              color: "text.primary",
              fontSize: "0.75rem",
              mb: 0.25,
            }}
          >
            Amount
          </Typography>

          <Typography
            variant='h6'
            sx={{
              fontWeight: 600,
              color: "secondary.main",
              fontSize: { xs: "1rem", md: "1.1rem" },
            }}
          >
            {formatAmount(-shareOfExpenses?.amount || 0)}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default ShareOfExpenses;
